import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../../../../contexts/theme';
import styles from './darkModeToggle.module.css';
import { useTranslation } from 'react-i18next';

export const DarkModeToggle: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <Tooltip
      title={<Typography variant="body2">{isDarkMode ? t("Light mode") : t("Dark mode")}</Typography>}
      placement="top"
      arrow
    >
      <IconButton
        size="small"
        className={styles.icon}
        aria-label="toggle dark mode"
        onClick={toggleDarkMode}
      >
        {isDarkMode ? <Brightness7 fontSize="inherit" /> : <Brightness4 fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
};
